// extracted by mini-css-extract-plugin
module.exports = {"warnIcon":"style__warnIcon___1gW7J"};